/*
 * Klimtec, Ergänzungen zur Craft-Navigation.
 *
 * Craft öffnet Dropdowns im Header nur per Klick, weil sie als
 * <details>-Element gebaut sind. Auf Geräten mit echtem Zeiger ist das
 * ungewohnt. Dieses Skript öffnet sie zusätzlich beim Überfahren.
 *
 * Touchgeräte bleiben unberührt: Dort gibt es kein Hover, und ein
 * simuliertes würde das erste Antippen verschlucken.
 */
(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!canHover.matches) return;

  const header = document.querySelector('.header');
  if (!header) return;

  const menus = header.querySelectorAll('details[id^="Details-HeaderMenu-"]');
  if (!menus.length) return;

  const CLOSE_DELAY = 180;
  let closeTimer;

  const closeAll = (except) => {
    menus.forEach((menu) => {
      if (menu !== except) menu.open = false;
    });
  };

  menus.forEach((menu) => {
    menu.addEventListener('mouseenter', () => {
      window.clearTimeout(closeTimer);
      closeAll(menu);
      menu.open = true;
    });

    /* Kurze Verzögerung, damit der Weg vom Menüpunkt ins Untermenü
       nicht schon als Verlassen zählt. */
    menu.addEventListener('mouseleave', () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        menu.open = false;
      }, CLOSE_DELAY);
    });
  });

  header.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') closeAll(null);
  });
})();
